/**
 * AlertaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Alerta} from '@/model/resource/Alerta'

/* TODO: review generated class */
@HttpExclude()
export class AlertaCollection extends PageCollection<Alerta> {
  constructor() {
    super(Alerta)
  }

  queryAsPage() {
    return this.listAlerta()
  }

  async listAlerta() {
    return await Request.get(`/admin/alerta`, {params: this.params})
      .name('listAlerta')
      .as(this)
      .getResponse()
  }

  async listCsvAlerta() {
    return await Request.get(`/admin/alerta/csv`, {params: this.params})
      .name('listCsvAlerta')
      .as(this)
      .getResponse()
  }
}
